/**
 * No styling, just the code as plain text.
 * Will add line numbers and padding if requested, of course.
 */
import { Theme } from '../index.js'
export const theme: Theme = { _: s => s }
